import ApiService from '@/services/ApiService';
import { AxiosResponse } from 'axios';
import { ActionContext } from 'vuex';
import IGlobalState from '@/interfaces/IGlobalState';
import { IModalData } from '@/services/layers/IModalData';
import EventIconMapperService from '@/services/EventIconMapperService';

export default {
  updateParkingZones(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchParkingZones()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateParkingZones', res.data);
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateParkings(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchParkings()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateParkings', res.data);
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateParkingMeters(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchParkingMeters()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateParkingMeters', res.data);
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateParkingSpots(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchParkingSpots()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateParkingSpots', res.data);
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateParkingGroups(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchParkingGroups()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateParkingGroups', res.data);
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateSettings(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchSettings()
      .then((res: AxiosResponse<any>) => {
        if (localStorage.getItem('defaultSettings') === 'true') {
          context.commit('updateSettings', res.data);
          context.commit('updateVisibilityOfModules', res.data);
          context.commit('updateSegmentsConfig', res.data.segmentsConfig);
        } else {
          context.commit('updateVisibilityOfModules', res.data);
          context.commit('updateSegmentsConfig', res.data.segmentsConfig);
        }
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateEvents(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchEvents()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateEvents', res.data);
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateCurrentWeather(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchCurrentWeather()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateCurrentWeather', res.data);
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateWeatherStations(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchWeatherStations()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateWeatherStations', res.data);
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updatePosts(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchPosts()
      .then((res: AxiosResponse<any>) => {
        context.commit('updatePosts', res.data);
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  panAndShowModalForEvent(context: ActionContext<IGlobalState, IGlobalState>, payload: any) {
    // @ts-ignore
    const eventLayers = [
      // @ts-ignore
      ...context.state.leafletLayers.eventsAccidents.GetMarkers(),
      // @ts-ignore
      ...context.state.leafletLayers.eventsBuilding.GetMarkers(),
      // @ts-ignore
      ...context.state.leafletLayers.eventsBlocks.GetMarkers(),
      // @ts-ignore
      ...context.state.leafletLayers.eventsHazard.GetMarkers(),
    ];
    const marker = eventLayers.find(o => o.data.metaData.id === payload.eventId);
    const { metaData } = marker.data;

    const modalData: IModalData = {
      title: metaData.name,
      content: metaData.description,
      navigationPoint: undefined,
      lastUpdate: metaData.updateTime,
      icon: EventIconMapperService(metaData.category.eventCode),
    };

    context.commit('displayModal', modalData);

    context.state.leafletMapInstance.flyTo({
      lat: marker.position.lat,
      lng: marker.position.lng,
    }, 17);
  },
};
